import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseModalComponent } from '../../../../models/base/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { BaseUser } from '../../../../models/base/base-user';
import { ChangeEmailRequest } from '../../../../models/users/requests/change-email-request';
import { MemberRecord } from '../../../../models/users/dto/member-record';
import { ChangeMemberEmailModalViewModel } from './change-member-email-modal-view-model';

@Component({
  selector: 'app-change-member-email-modal',
  templateUrl: './change-member-email-modal.component.html',
  styleUrls: ['./change-member-email-modal.component.scss'],
  providers: [ChangeMemberEmailModalViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeMemberEmailModalComponent extends BaseModalComponent {
  public ignoreEscape: boolean = false;

  constructor(protected activeModal: NgbActiveModal) {
    super(activeModal);
  }

  public viewModel = inject(ChangeMemberEmailModalViewModel);

  public req$ = this.viewModel.changeEmailReq$;
  public isLoading$ = this.viewModel.isLoading$;
  public userEmail$ = this.viewModel.member$.pipe(map(u => u?.email));

  public setupBindings(): void {
    this.viewModel.dismissModalSubject.subscribeWhileAlive({
      owner: this,
      next: close => {
        if (close instanceof BaseUser) {
          this.close(close);
        } else {
          this.close(false);
        }
      }
    });
  }

  public setupViews(): void {}

  public setMember(member: MemberRecord): void {
    this.viewModel.setMember(member);
  }

  public submitForm(req: ChangeEmailRequest): void {
    this.viewModel.formSubmitted(req);
  }

  public closeModal(): void {
    this.viewModel.closeModal();
  }
}
